<template>
    
    <!-- Layout Footer -->
    <a-layout-footer>

        <!-- Footer Navigation Menu -->
        <a-menu mode="horizontal">
        </a-menu>
        <!-- / Footer Navigation Menu -->

        <!-- Copyright Notice -->
		<p class="copyright">
			Copyright © 2022 Order Manager App
			by <a href="https://transoft.no">TranSoft</a>.
		</p>
		<!-- / Copyright Notice -->


    </a-layout-footer>
    <!-- / Layout Footer -->

</template>

<script>
export default {
    
}
</script>